module.exports = "/static/assets/a6f5509545228031a0979c7c0c088b77.png";